import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../../../store';
import { PayloadAction } from '../../../../../store.model';
import {
    WpDisplayConfig,
    WpViewHeader,
} from '../../../winning-percentage/core';
import { ActionType } from '../../main.action';
import { FLWinningService } from '../../services/fl-winning.service';

import { Reload, reloadResult } from './reload.action';

export const reloadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.WP_MAIN__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const service =
                deps.injector.get<FLWinningService>(FLWinningService);

            return forkJoin([
                service.retrieveDisplayConfig(),
                service.retrieveViewHeader(),
            ]).pipe(
                map((ret: [WpDisplayConfig, WpViewHeader]) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            config: ret[0],
                            header: ret[1],
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
